import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';
import { cashSettlementFactory } from '../utils/settlement';

type TUseCreateCashSettlementQueryConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useCreateCashSettlementQuery({
  onReject,
  onSuccess,
}: TUseCreateCashSettlementQueryConfigs) {
  const {
    isPending: isLoadingCreateCashSettlement,
    isError: isErrorCreateCashSettlement,
    execute: createCashSettlement,
    isSuccess: isSuccessCreateCashSettlement,
    ...query
  } = useMutation(
    ({ formModel }) =>
      API.createCashSettlement(cashSettlementFactory(formModel)),
    { onReject, onSuccess }
  );

  return {
    createCashSettlement,
    isErrorCreateCashSettlement,
    isLoadingCreateCashSettlement,
    isSuccessCreateCashSettlement,
    query,
  };
}
